export default __webpack_public_path__ + "static/media/banner1.58b404cc.svg";